import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { TeacherRoutingModule } from './teacher-routing.module';
import { TeacherComponent } from './teacher.component';
import { ComponentsModule } from '../../../components/components.module';
import { NgxSliderModule } from '@angular-slider/ngx-slider';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { PaginatorIntlService } from './paginator';
import { TranslateService } from '@ngx-translate/core';
import { MatTabsModule } from '@angular/material/tabs';

@NgModule({
  declarations: [TeacherComponent],
  imports: [
    CommonModule,
    TeacherRoutingModule,
    ComponentsModule,
    NgxSliderModule,
    MatTabsModule
  ],
  providers: [
    {
      provide: MatPaginatorIntl,
      useFactory: (translate: any) => {
        const service = new PaginatorIntlService();
        service.injectTranslateService(translate);
        return service;
      },
      deps: [TranslateService],
    },
  ],
})
export class TeacherModule {}
